import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { pluck, map } from 'rxjs/operators';
import { Observable, of, BehaviorSubject } from 'rxjs';
import { ImagilityBaseResponse } from 'src/app//data/models/response.model';

@Injectable({
  providedIn: 'root'
})
export class PetitionUpdateInitService {

  constructor(private httpClient: HttpClient) { }

  postupdatedPetition(updateType, payload) {
    return this.httpClient.post(`/${updateType}`, payload).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response.status && response.status === 200) {
          return response;
        }
        else {
          return null;
        }
      })
    );
  }

  getAllPBDocs(petitionId, isAttorneyChange, isServiceCenterChange) {
    return this.httpClient.get(`/updatePetition/petition/${petitionId}/documents?isAttorneyChange=${isAttorneyChange}&isServiceCenterChange=${isServiceCenterChange}`).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response.status && response.status === 200) {
          return response.data;
        }
        else {
          return null;
        }
      })
    );
  }

  generateAllDocs(petitionId, payload) {
    return this.httpClient.post(`/updatePetition/petition/${petitionId}/generate`, payload).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response.status && response.status === 200) {
          return response;
        }
        else {
          return null;
        }
      })
    );
  }

  generateForms(visatype, caseType, caseId, superTaskId, taskId, formType) {
    return this.httpClient.post(`/${visatype}/${caseType}/${caseId}/form/${formType}/generate?superTaskId=${superTaskId}&taskId=${taskId}`, {}).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response.status === 200) {
          return response;
        }
      })
    );
  }

  getCoverLetterTemplateList(companyId: number, payload: {}) {
    return this.httpClient.post(`/company/${companyId}/documentTemplate/list`, payload).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response && (response.status === 200 || response.status === 204)) {
          return response;
        }
      })
    );
  }

  generatePDF(visaType, caseType, caseId: number, letterType: string, payload) {
    return this.httpClient.post(`/${visaType}/${caseType}/${caseId}/letter/${letterType}/generate/pdf`, payload).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response.status === 200) {
          return response;
        }
      })
    );
  }

  generateFullPetition(visatype, caseType, caseId: number, draft: boolean) {
    return this.httpClient.post(`/${visatype}/${caseType}/${caseId}/generate/${draft}/fullpdf`, {}).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response.status === 200) {
          return response;
        }
      })
    );
  }


  getGenerateFullPetition(visatype, caseType, caseId: number, draft: boolean) {
    return this.httpClient.get(`/${visatype}/${caseType}/${caseId}/generate/${draft}/fullpdf`).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response.status === 200 || response.status === 204) {
          return response;
        }
      })
    );
  }

  generatePetition(petitionId, payload) {
    return this.httpClient.post(`/petitionBuilder/documents/${petitionId}`, payload).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response.status === 200) {
          return response;
        }
      })
    );
  }

  getPetitionDocs(petitionId) {
    return this.httpClient.get(`/petitionBuilder/documents/${petitionId}`).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response.status === 200) {
          return response;
        }
      })
    );
  }

  getPreview(visaType, caseType, caseId: number, letterType: string, superTaskId: number, taskId, payload) {
    return this.httpClient.post(`/${visaType}/${caseType}/${caseId}/letter/${letterType}/preview?superTaskId=${superTaskId}&taskId=${taskId}`, payload).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response.status === 200 || response.status === 204) {
          return response;
        }
      })
    );
  }

  postUpdateSeviceCenterAndAttorney(payload) {
    return this.httpClient.post(`/updateSeviceCenterAndAttorney`, payload).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response.status && response.status === 200) {
          return response;
        }
        else {
          return null;
        }
      })
    );
  }

}
